import { NgModule, ModuleWithProviders, Optional, SkipSelf } from '@angular/core'

import { AppPackageService } from './app-package.service'
import { CenterService } from './center.service'
import { CityService } from './city.service'
import { CountryService } from './country.service'
import { CoursesGroupService } from 'models/courses-group.service'
import { StatisticsService } from './statistics.service'
import { DeviceActivationService } from './device-activation.service'
import { FolderService } from './folder.service'
import { InfractionService } from './infraction.service'
import { AccessorInfractionService } from './accessor-infraction.service'
import { InteractiveService } from './interactive.service'
import { InteractiveContentItemService } from './interactive-content-item.service'
import { LessonQuizService } from './lesson-quiz.service'
import { LessonTextService } from './lesson-text.service'
import { LessonService } from './lesson.service'
import { ProgramService } from './program.service'
import { QuestionService } from './question.service'
import { SessionVersionService } from './session-version.service'
import { SessionService } from './session.service'
import { SettingService } from './setting.service'
import { SkillService } from './skill.service'
import { StartExamConfigService } from './start-exam-config.service'
import { StaticScreenService } from './static-screen.service'
import { SystemScreenService } from './system-screen.service'
import { UserService } from './user.service'
import { VideoService } from './video.service'
import { AudioService } from './audio.service'
import { SpeechService } from './speech.service'
import { DriverSessionService } from './driver-session.service'
import { ApiKeyService } from './api-key.service'
import { ExamService, SectionService } from './exams'
import { AppLocaleService } from './app-locale.service'
import { AppTranslationService } from './app-translation.service'
import { AbTestService } from './ab-test.service'
import { SessionImageService } from './session-image.service'
import { PifiaReviewService } from './pifia-review.service'
import { AvailableLocalesService } from './available-locales.service'
import { OnlineSessionService } from './online-session.service'
import { InterviewService } from './interview.service'
import { HubService } from './hub.service'
import { HubCourseService } from './hub-course.service'
import { HubRegistrationService } from './hub-registration.service'
import { HubStopService } from './hub-stop.service'
import { HubCourseStopService } from './hub-course-stop.service'
import { UserPermissionService } from './user-permissions.service'
import { ExportResultService } from './export-result.service'
import { AbExperimentService } from './ab-experiment.service'
import { AudioWithFoldersService } from './audios/audio-with-folders.service'
import { ReportService } from './report.service'
import { NotificationService } from './notification.service'
import { BriefingService } from './briefing.service'
import { TariffService } from './tariff.service'
import { TariffGroupsService } from './tariff-groups.service'

@NgModule({})

export class ModelsModule {
  constructor (@Optional() @SkipSelf() parentModule: ModelsModule) {
    if (parentModule) {
      throw new Error('ModelsModule is already loaded. Import it in the AppModule only')
    }
  }

  static forRoot(params: Object): ModuleWithProviders {
    return {
      ngModule: ModelsModule,
      providers: [
        AppPackageService,
        CenterService,
        CityService,
        CountryService,
        CoursesGroupService,
        DeviceActivationService,
        FolderService,
        InfractionService,
        AccessorInfractionService,
        InteractiveService,
        InteractiveContentItemService,
        LessonQuizService,
        LessonTextService,
        LessonService,
        ProgramService,
        QuestionService,
        SessionVersionService,
        SessionService,
        SettingService,
        SkillService,
        StartExamConfigService,
        StaticScreenService,
        SystemScreenService,
        UserService,
        VideoService,
        AudioService,
        SpeechService,
        DriverSessionService,
        ApiKeyService,
        ExamService, SectionService,
        AppLocaleService,
        AppTranslationService,
        AbTestService,
        SessionImageService,
        PifiaReviewService,
        AvailableLocalesService,
        StatisticsService,
        OnlineSessionService,
        InterviewService,
        HubService,
        HubCourseService,
        HubRegistrationService,
        HubStopService,
        HubCourseStopService,
        UserPermissionService,
        ExportResultService,
        AbExperimentService,
        AudioWithFoldersService,
        ReportService,
        NotificationService,
        BriefingService,
        TariffGroupsService,
        TariffService
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/models.module.ts